module.exports = __webpack_public_path__ + "img/samaritains_esta.70a0c939.jpg";